module.exports = __webpack_public_path__ + "img/community-bg.1726497e.svg";